// PGA programs a screened product can be flagged under, matching the codes the
// product service stores in ProductScreeningResult.pga_programs (see
// biteservices product/src/utils/product-pga-programs.ts). `name` is the
// agency label from the PGA flag schemas (pga-schema.ts); `short` is the
// compact badge text.
export interface PgaProgramInfo {
  code: string;
  short: string;
  name: string;
}

export const PGA_PROGRAMS: PgaProgramInfo[] = [
  { code: 'FDA', short: 'FDA', name: 'FDA' },
  { code: 'NHT', short: 'NHTSA', name: 'NHTSA' },
  { code: 'CPS', short: 'CPSC', name: 'CPSC' },
  { code: 'DTC', short: 'DDTC', name: 'DDTC / DOT' },
  { code: 'DEA', short: 'DEA', name: 'DEA' },
  { code: 'AMS', short: 'AMS', name: 'USDA AMS' },
  { code: 'APH_CORE', short: 'APHIS', name: 'APHIS CORE' },
  { code: 'APH_LACEY', short: 'APHIS LCY', name: 'APHIS Lacey' },
  { code: 'ATF', short: 'ATF', name: 'ATF' },
  { code: 'EPA_TSCA', short: 'TSCA', name: 'EPA TSCA' },
  { code: 'EPA_HFC', short: 'EPA HFC', name: 'EPA HFC' },
  { code: 'EPA_PST', short: 'EPA PST', name: 'EPA Pesticide' },
  { code: 'EPA_VNE', short: 'EPA VNE', name: 'EPA Vehicle & Engine' },
  { code: 'FSIS', short: 'FSIS', name: 'FSIS' },
  { code: 'FWS', short: 'FWS', name: 'US Fish & Wildlife' },
  { code: 'NMF_370', short: 'NMFS 370', name: 'NMFS 370' },
  { code: 'NMF_AMR', short: 'NMFS AMR', name: 'NMFS AMR' },
  { code: 'NMF_COA', short: 'NMFS COA', name: 'NMFS COA' },
  { code: 'NMF_SIM', short: 'NMFS SIMP', name: 'NMFS SIMP' },
  { code: 'OMC', short: 'OMC', name: 'OMC' },
  { code: 'TTB', short: 'TTB', name: 'TTB' },
  {
    code: 'OTHER',
    short: 'Other PGA',
    name: 'Other PGA (agency not recognized)',
  },
];

const PGA_PROGRAMS_BY_CODE = new Map(
  PGA_PROGRAMS.map((program) => [program.code, program]),
);

// Unknown codes (e.g. a program added on the server first) still render.
export const pgaProgramInfo = (code: string): PgaProgramInfo =>
  PGA_PROGRAMS_BY_CODE.get(code) ?? { code, short: code, name: code };
